document.addEventListener('DOMContentLoaded', function () {
    new bootstrap.Modal(document.getElementById('newsModal')).show();;
});